// extracted by mini-css-extract-plugin
export var arrowClosed = "perioddesc-module--arrow-closed--xx-pA";
export var arrowOpen = "perioddesc-module--arrow-open--OwIpN";
export var buttonClosed = "perioddesc-module--button-closed--GxJuX";
export var buttonOpen = "perioddesc-module--button-open--sAo+j";
export var descClosed = "perioddesc-module--desc-closed--ovpDC";
export var divClosed = "perioddesc-module--div-closed--noCiK";
export var divOpen = "perioddesc-module--div-open--3Ftqe";
export var rotate = "perioddesc-module--rotate--85Rll";